import {createActionObject} from '../../../../../redux/utils'
import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'
import * as api from '../../../apiCalls'
import {mergeHolidaysWithSameDate} from '../holidayList/utils'
import {ICalParser} from '../../../../../parsers/ical/ICalParser'
import {getHolidays, getYear} from './selectors'
import {convertEffectiveDateInWorkSchedule, sortHolidaysArray} from '../../../utils'
import {loadedDataSet} from '../../../actions'
import {batched} from '../../../../../redux/batch'
import * as HolidaysListActions from '../holidayList/actions'
import {isShownHolidayList} from '../holidayList/selectors'
import {DateFormat} from '../../../../../date_format'

const HIGHLIGHT_IMPORTED_HOLIDAYS_DELAY = 3000

export const openPanel = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.OPEN_PANEL))
}
export const closePanel = createAction(ActionTypes.CLOSE_PANEL)

export const loadData = createAction(ActionTypes.LOAD_DATA)
export const loadDataSuccess = createAction(ActionTypes.LOAD_DATA_SUCCESS)
export const loadDataFailure = createAction(ActionTypes.LOAD_DATA_FAILURE)

export const startImportHolidays = createAction(ActionTypes.IMPORT_HOLIDAYS_START)
export const completeImportHolidays = createAction(ActionTypes.IMPORT_HOLIDAYS_COMPLETE)

export const openPreviewHolidaysPanelBySelectedCountry = (country) => (dispatch) => {
    dispatch(openPanel())
    dispatch(loadHolidays(country))
}

export const openPreviewHolidaysPanelByFileImport = (file) => (dispatch) => {
    dispatch(openPanel())
    dispatch(loadHolidaysFromFile(file))
}

export const importHolidays = () => (dispatch, getState) => {
    let state = getState()
    const year = getYear(state)
    const holidays = getHolidays(state)
    dispatch(startImportHolidays())
    api.addHolidays(year, holidays)
        .then(batched(data => {
            if (!isShownHolidayList(state)) {
                dispatch(HolidaysListActions.setPanelSelectedYear(year))
                dispatch(HolidaysListActions.setPanelShown())
            }

            dispatch(loadedDataSet({
                corporateDays: {[year]: data.corporateDays},
                defaultWorkSchedules: convertEffectiveDateInWorkSchedule(data.defaultWorkSchedules)
            }))

            dispatch(HolidaysListActions.setListTransformed(true))
            dispatch(completeImportHolidays())
            const dates = holidays.map(h => h.date)
            dispatch(HolidaysListActions.addImportedHolidays(dates))
            setTimeout(() => dispatch(HolidaysListActions.removeImportedHolidays(dates)), HIGHLIGHT_IMPORTED_HOLIDAYS_DELAY)
        }))
        .catch(error => {
            console.error(error)
            dispatch(completeImportHolidays())
        })
}

const loadHolidays = (country) => (dispatch, getState) => {
    dispatch(loadData())
    api.getHolidays(country.id, getYear(getState()))
       .then(data => {
           dispatch(loadDataSuccess({
               hasHolidaysInPast: data.hasHolidaysInPast,
               holidays: mergeHolidaysWithSameDate(data.holidays),
               country: country.name,
           }))
       })
       .catch(error => {
           console.error(error)
           dispatch(loadDataFailure())
       })
}

const loadHolidaysFromFile = (file) => (dispatch, getState) => {
    dispatch(loadData())
    new ICalParser().parseHolidays(file, getYear(getState()), (holidays) => {
            const today = window.currentUserTime().clearTime().getTime()
            const formatter = new DateFormat("yyyy-MM-dd")
            const futureHolidays = holidays
                                    .filter(holiday => holiday.date >= today)
                                    .map(holiday => {
                                        return {
                                            date: formatter.formatDate(holiday.date),
                                            name: holiday.name
                                        }
                                    })
            dispatch(loadDataSuccess({
                holidays: sortHolidaysArray(futureHolidays),
                hasHolidaysInPast: futureHolidays.length < holidays.length,
                fileName: file.name
            }))
        },
        (error) => {
            alert('Error while parsing iCal file: ' + error.message)
            dispatch(loadDataFailure())
        })
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/actions.js